import { addYears, getMonth, getYear } from 'date-fns';

/**
 * Returns the max year that can be used to generate a quotation for a particular car.
 *
 * @param minMonthForNextYear - The min month that will be used to consider the max year to be next year
 */
export default function getMaxYear(minMonthForNextYear = 0): number {
  const currentDate = Date.now();
  const currentMonthNumber = getMonth(currentDate);
  if (currentMonthNumber < minMonthForNextYear) {
    return getYear(currentDate);
  }
  return getYear(addYears(currentDate, +1));
}
